import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from "vue";
import { API_BIS_DATA_SYNC_TASKS } from "@/configs/Apis";
import DuduAjax from "@/utils/DuduAjax";
import { useStore } from "@/stores";
import DataSyncFailLogs from "./DataSyncFailLogs.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DataSyncHistory',
  emits: ["close"],
  setup(__props, { emit }) {

const store = useStore();


const projectId = computed(() => {
  const pInfo: any = (store.state as any).project.info || {};
  return pInfo.id || 0;
});

const isLoading = computed(() => store.state.isLoading);

const visible = ref(true);
const dataItems = ref<Array<any>>([]);
const status = ref("");

const recordCount = ref(0);
const pageSize = ref(20);
const pageIndex = ref(1);

const statusOptions = [
  { value: "RUNNING", label: "同步中" },
  { value: "SUCCESS", label: "已完成" },
  { value: "PARTIAL", label: "部分完成" },
  { value: "FAILED", label: "失败" },
];

const statusLabel = (value: string) => {
  const item = statusOptions.find((option) => option.value === value);
  return item ? item.label : value || "-";
};

const statusTagType = (value: string) => {
  switch (value) {
    case "SUCCESS":
      return "success";
    case "PARTIAL":
      return "warning";
    case "FAILED":
      return "danger";
    case "RUNNING":
    default:
      return "info";
  }
};

const formatTime = (value: string) => {
  if (!value) {
    return "-";
  }
  return value.replace("T", " ").split(".")[0];
};

const loadDataSyncHistory = () => {
  DuduAjax.get<{ count: number; data: Array<any> }>(API_BIS_DATA_SYNC_TASKS, {
    projectId: projectId.value,
    status: status.value,
    page: pageIndex.value - 1,
    pageSize: pageSize.value,
  }).then((entity) => {
    recordCount.value = entity.count;
    dataItems.value = entity.data || [];
  });
};

const reloadData = () => {
  pageIndex.value = 1;
  loadDataSyncHistory();
};

const onCurrentPageChange = (page: number) => {
  pageIndex.value = page;
  loadDataSyncHistory();
};

const onPageSizeChange = (size: number) => {
  pageSize.value = size;
  reloadData();
};

const closeDialog = () => {
  emit("close");
};

// 失败明细弹窗
const failLogsVisible = ref(false);
const failLogRequestUuid = ref("");

const showFailLogs = (row: any) => {
  failLogRequestUuid.value = row.requestUuid || "";
  failLogsVisible.value = true;
};

onMounted(() => {
  loadDataSyncHistory();
});

return { __sfc: true,store, emit, projectId, isLoading, visible, dataItems, status, recordCount, pageSize, pageIndex, statusOptions, statusLabel, statusTagType, formatTime, loadDataSyncHistory, reloadData, onCurrentPageChange, onPageSizeChange, closeDialog, failLogsVisible, failLogRequestUuid, showFailLogs, DataSyncFailLogs }
}

})